import { Reveal } from "@/components/motion";
import { Clock } from "lucide-react";

const schedule = [
  { day: "Monday", hours: "10:00 AM – 1:30 PM" },
  { day: "Tuesday", hours: "10:00 AM – 1:30 PM" },
  { day: "Wednesday", hours: "10:00 AM – 1:30 PM" },
  { day: "Thursday", hours: "10:00 AM – 1:30 PM" },
  { day: "Friday", hours: "10:00 AM – 12:30 PM", accent: true },
  { day: "Saturday", hours: "10:00 AM – 1:30 PM" },
  { day: "Sunday", hours: "10:00 AM – 12:30 PM", accent: true },
];

export default function Timings() {
  return (
    <section id="timings" className="py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <Reveal>
            <div className="w-12 h-12 rounded-2xl bg-[var(--teal-light)] flex items-center justify-center text-[var(--teal)] mb-6">
              <Clock size={22} />
            </div>
            <p className="text-[var(--teal)] text-sm tracking-[0.25em] uppercase mb-4">Consultation Hours</p>
            <h2 className="font-display text-4xl sm:text-5xl tracking-tight text-[var(--ink)]">
              We're open through the week.
            </h2>
            <p className="mt-5 text-[var(--ink-soft)] leading-relaxed">
              Appointments are scheduled every 10 minutes. Pick a day and slot in the booking form below.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-7 lg:col-start-6">
          <Reveal delay={0.12}>
            <div className="rounded-3xl border border-border overflow-hidden">
              {schedule.map((s, i) => (
                <div
                  key={s.day}
                  data-testid={`timing-${s.day.toLowerCase()}`}
                  className={`flex items-center justify-between px-7 py-5 ${i !== schedule.length - 1 ? "border-b border-border" : ""} ${
                    s.accent ? "bg-[var(--teal-light)]/40" : "bg-white"
                  }`}
                >
                  <span className="font-display text-2xl text-[var(--ink)]">{s.day}</span>
                  <span className={`text-base font-medium ${s.accent ? "text-[var(--teal-dark)]" : "text-[var(--ink-soft)]"}`}>{s.hours}</span>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
